import React from 'react'
import { withRouter } from "react-router";
import {_baseUrl} from "./../helpers/makeUrl";

class Lang extends React.Component {
	constructor (props) {
		super(props);
		this.handleClick = this.handleClick.bind(this)
	}

	handleClick(lang) {
		this.props.changeLangue(lang)
	}

	render() {
		let loc = this.props.location;
		return (
			<div className='langs'>
				<a href={_baseUrl(loc.pathname.replace('/en/','/pl/')+loc.search)} className={global.lang == 'pl' ? 'active' : ''}>pl</a>
			</div>
		)
	}
}


export default withRouter(Lang);
